import React, { useState, useEffect } from "react";
import classes from "./controls.module.scss";
import {
  Box
} from '@mui/material';
import { DataGrid } from '@genesis/ui-kit';
import SnackBar from "../../Shared/Snackbar/Snackbar";

const AdminControlsDataGrid = (props) => {
  const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    let searchApiValue = props.searchApiValue;
    console.log("hello")
    

  const CustomFooter = () => {
    return (null);
  }

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const handleRowEditCommit = React.useCallback(
    (params) => {
          // send params to save 
          props.handleSave(params, searchApiValue)
         },
    []
    
  );

  const handleEditRowsModelChange = React.useCallback((newModel) => {
    const updatedModel = { ...newModel };
    Object.keys(updatedModel).forEach((id) => {
      if (updatedModel[id].status) {
        const isValid = (updatedModel[id].status.value === "On" || updatedModel[id].status.value === "ON" || updatedModel[id].status.value === "Off" || updatedModel[id].status.value === "OFF") ? true : false;
        updatedModel[id].status = { ...updatedModel[id].status, error: !isValid };
        if(!isValid) {
          setAlertOpen({
            open: true,
            severity: "error",
            message : "Please select On or Off only for status"
          })
        }
      }
    });
    
  }, []);
  
    return(
      <div style={{marginTop:"30px"}}>
        <div><span style={{fontSize:"18px", fontWeight:"bold", marginLeft:"5px", marginBottom:"5px"}}>{props.rows.length}</span><span style={{fontSize:"18px", fontWeight:"bold", marginLeft:"5px", marginBottom:"5px"}}> Results Found</span></div>
    <Box sx={{ height: props.height ? props.height : 400, width: props.width ? props.width :"70%", marginTop: 15 }} >
    
    <DataGrid  
      rows={props.rows} 
      columns={props.columns} 
      components={{Footer: CustomFooter}} 
      onCellEditCommit={handleRowEditCommit}
      onEditRowsModelChange={handleEditRowsModelChange}
      disableSelectionOnClick={props.disableSelectionClick ? props.disableSelectionClick : 'false'}
      />
    </Box>
    <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
    </div>
    ); 
}

export default AdminControlsDataGrid;